import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

const DiffBlock = ({ diff }) => {
    const [expanded, setExpanded] = useState({});
    const [isLong, setIsLong] = useState({});
    const refs = useRef({});
    useEffect(() => {
        const result = {};

        Object.keys(refs.current).forEach((key) => {
            const el = refs.current[key];
            if (el) {
                result[key] = el.scrollHeight > el.clientHeight;
            }
        });

        setIsLong(result);
    }, [diff]);
    const toggle = (key) => {
        setExpanded((prev) => ({
            ...prev,
            [key]: !prev[key],
        }));
    };
    if (!diff) return null;

    const updated = diff.updated || diff;
    const keys = Object.keys(updated || {});
    if (keys.length === 0) return null;

    return (
        <div className="audit-diff">
            <div className="audit-diff__title">Changed fields</div>

            <div className="audit-diff__tableWrap">
                <table className="table table-sm mb-0">
                    <thead>
                        <tr>
                            <th style={{ width: '25%' }}>Field</th>
                            <th>From</th>
                            <th>To</th>
                        </tr>
                    </thead>
                    <tbody>
                        {keys.map((field) => (
                            <tr key={field}>
                                <td><code>{field}</code></td>
                                <td>
                                    <div className="audit-ellipsisCol">
                                        <pre
                                            ref={(el) => {
                                                refs.current[`${field}-from`] = el;
                                            }}
                                            className={`audit-diff__cellPre ${!expanded[`${field}-from`] ? 'audit-diff__cellPre--ellipsis' : ''
                                                }`}
                                        >
                                            {JSON.stringify(updated[field]?.from ?? null, null, 2)}
                                        </pre>

                                        {isLong[`${field}-from`] && (
                                            <span
                                                className="audit-ellipsisLink audit-ellipsisLink--bottom"
                                                onClick={() => toggle(`${field}-from`)}
                                            >
                                                {expanded[`${field}-from`] ? 'less' : 'more'}
                                            </span>
                                        )}
                                    </div>
                                </td>
                                <td>
                                    <div className="audit-ellipsisCol">
                                        <pre
                                            ref={(el) => {
                                                refs.current[`${field}-to`] = el;
                                            }}
                                            className={`audit-diff__cellPre ${!expanded[`${field}-to`] ? 'audit-diff__cellPre--ellipsis' : ''
                                                }`}
                                        >
                                            {JSON.stringify(updated[field]?.to ?? null, null, 2)}
                                        </pre>

                                        {isLong[`${field}-to`] && (
                                            <span
                                                className="audit-ellipsisLink audit-ellipsisLink--bottom"
                                                onClick={() => toggle(`${field}-to`)}
                                            >
                                                {expanded[`${field}-to`] ? 'less' : 'more'}
                                            </span>
                                        )}
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

DiffBlock.propTypes = {
    diff: PropTypes.any,
};

DiffBlock.defaultProps = {
    diff: null,
};

export default DiffBlock;
